export default __webpack_public_path__ + "static/media/rex2.13a9c1ec.png";